/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Receipt_Change_StorageInputs */



/**
* | output |
* | --- |
* | "Storage {from} → {to}" |
*
* @param {Receipt_Change_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_change_storage = /** @type {((inputs: Receipt_Change_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Change_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher ${i?.from} → ${i?.to}`)
	return /** @type {LocalizedString} */ (`Storage ${i?.from} → ${i?.to}`)
});